"use client";
import { useReducer } from "react";
import React from "react";
import PropTypes from "prop-types";
import SearchContext from "./searchContext";
import SearchReducer from "./searchReducer";

const SearchState: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const initialState = {
    searchedDataFromLanding: undefined,
    categoryFromLanding: undefined,
  };
  const [state, dispatch] = useReducer(SearchReducer, initialState);
  const saveSearchInfo = (data: any) => {
    dispatch({
      type: "SAVE_SEARCH",
      payload: data,
    });
  };
  const saveCategory = (category: string) => {
    //string as Id
    dispatch({
      type: "SAVE_CATEGORY",
      payload: category,
    });
  };
  return (
    <SearchContext.Provider
      value={{
        loading: state.loading,
        saveSearchInfo,
        saveCategory,
        searchedDataFromLanding: state.searchedDataFromLanding,
        categoryFromLanding: state.categoryFromLanding,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

SearchState.propTypes = {
  children: PropTypes.any,
};

export default SearchState;
